export const SUPPORT_PATH = { de: "unterstuetzen", en: "support" };
export const SUPPORT_SUBPAGE_PATH = {
  membership: { de: "foerdermitgliedschaft", en: "membership" },
  sponsoring: { de: "sponsoring", en: "sponsoring" },
  volunteer: { de: "ehrenamt", en: "volunteer" },
};
